import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';
import lottie from 'lottie-web';
import Calendar from './../components/calendar';

export default class Home {
    constructor() {
        // Home

        this.header();
        this.page();
        this.animation();
        
        Calendar.init();
    }

    header() {
        tns({
            container: document.querySelector('.header__images'),
            items: 1,
            slideBy: 1,
            autoplay: false,
            gutter: 30,
            loop: false,
            mouseDrag: true,
            nav: false,
            controls: false,
            speed: 650,
            autoHeight: true,
            controlsText: ['<svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54"><g fill="none" stroke="#FFFFFF" stroke-width="3"><circle cx="27" cy="27" r="27" stroke="none"/><circle cx="27" cy="27" r="25.5" fill="none"/></g><g transform="translate(26.308 39.146) rotate(-135)"><path d="M18.154,0,0,18.154" transform="translate(0 0)" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/><path d="M7.771,7.771H0V0" transform="translate(0 10.383)" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></g></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54"><g fill="none" stroke="#FFFFFF" stroke-width="3"><circle cx="27" cy="27" r="27" stroke="none"/><circle cx="27" cy="27" r="25.5" fill="none"/></g><g transform="translate(26.308 39.146) rotate(-135)"><path d="M18.154,0,0,18.154" transform="translate(0 0)" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/><path d="M7.771,7.771H0V0" transform="translate(0 10.383)" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></g></svg>'],
            responsive: {
                1024: {
                    controls: true,
                },
                768: {
                    nav: true,
                }
            }
        });

        const btn = document.querySelector('.header__scroll');
        if(btn) {
            btn.addEventListener('click', () => {
                window.scrollTo({
                    top: window.innerHeight,
                    left: 0,
                    behavior: 'smooth',
                });
            });
        }
    }

    page() {
        tns({
            container: document.querySelector('.page__container'),
            items: 1,
            slideBy: 1,
            autoplay: false,
            gutter: 30,
            loop: false,
            mouseDrag: true,
            navPosition: 'bottom',
            controls: false,
            speed: 650,
            controlsText: ['<svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54"><g fill="none" stroke="#262626" stroke-width="3"><circle cx="27" cy="27" r="27" stroke="none"/><circle cx="27" cy="27" r="25.5" fill="none"/></g><g transform="translate(26.308 39.146) rotate(-135)"><path d="M18.154,0,0,18.154" transform="translate(0 0)" fill="none" stroke="#262626" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/><path d="M7.771,7.771H0V0" transform="translate(0 10.383)" fill="none" stroke="#262626" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></g></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54"><g fill="none" stroke="#262626" stroke-width="3"><circle cx="27" cy="27" r="27" stroke="none"/><circle cx="27" cy="27" r="25.5" fill="none"/></g><g transform="translate(26.308 39.146) rotate(-135)"><path d="M18.154,0,0,18.154" transform="translate(0 0)" fill="none" stroke="#262626" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/><path d="M7.771,7.771H0V0" transform="translate(0 10.383)" fill="none" stroke="#262626" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></g></svg>'],
            responsive: {
                1024: {
                    items: 3,
                    controls: true,
                },
                768: {
                    items: 2,
                },
            }
        });
    }

    animation() {
        lottie.loadAnimation({
            container: document.querySelector('.header__scrollContainer'),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: 'wp-content/themes/hg-tourisme/assets/js/animations/scroll.json'
        });
    }
}